<script>
    import Layout from '../../layouts/main'
    import PageHeader from '@/components/page-header'

    import { authWellyMethods } from "@/state/helpers";
    import { apiCore }  from '../../../constants'
    import axios from 'axios'
    import Swal from "sweetalert2"

    export default {
        components: { Layout, PageHeader },
        props: {},
        data() {
            return {
                user: null,
                resto: null,
                sucursales: null,
                apiCoreHtml: apiCore
            };
        },
        computed: {
        },
        created: () => {
        },
        methods: {
            ...authWellyMethods,
            logout(){
                localStorage.clear();
                window.location = "/login";
            },
            getSucursales(){
                let url = `${apiCore}/api/resto/sucursales`
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                //console.log(tok)
                axios
                .get(url, {
                        headers: {'Authorization': tok},
                })
                .then(r => r.data)
                .then(res => {
                    // eslint-disable-next-line
                    //console.log(res)
                    if (res.valid) {
                        this.sucursales = res.restos
                    } 
                })
            },
            changeEfective(valor){
                let url = valor 
                    ? `${apiCore}/api/welly/admin/payment/efective/resto`
                    : `${apiCore}/api/welly/admin/payment/no/efective/resto`
                    
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                console.log(tok)
                let body = {
                    "motive":"",
                    "type":1
                }
                axios
                .put(url, body, {
                        headers: {'Authorization': tok},
                })
                .then(r => r.data)
                .then(res => {
                    if (res.valid) {
                        this.getInfoResto();
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: "Cambio realizado con éxito.",
                            showConfirmButton: false,
                            timer: 4500
                        });
                    }else{
                        this.resto.paymentWithEfective = !valor;
                        Swal.fire({
                            position: "top-end",
                            icon: "warning",
                            title: "El cambio no pudo ser realizado",
                            showConfirmButton: false,
                            timer: 4500
                        });
                    }
                })
            },
            changeCard(valor){
                let url = valor 
                    ? `${apiCore}/api/welly/admin/payment/card/resto`
                    : `${apiCore}/api/welly/admin/payment/no/card/resto`
                    
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                console.log(tok)
                let body = {
                    "motive":"",
                    "type":1
                }
                axios
                .put(url, body, {
                        headers: {'Authorization': tok},
                })
                .then(r => r.data)
                .then(res => {
                    if (res.valid) {
                        this.getInfoResto();
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: "Cambio realizado con éxito.",
                            showConfirmButton: false,
                            timer: 4500
                        });
                    }else{
                        this.resto.paymentWithCard = !valor;
                        Swal.fire({
                            position: "top-end",
                            icon: "warning",
                            title: "El cambio no pudo ser realizado",
                            showConfirmButton: false,
                            timer: 4500
                        });
                    }
                })
            },
            getInfoResto(){
                let url = `${apiCore}/api/resto`
                //console.log(url)
                let tok = "Bearer "+this.user.token
                // eslint-disable-next-line
                axios
                .get(url, {
                    headers: {'Authorization': tok},
                })
                .then(r => r.data)
                .then(res => {
                    if (res.valid) {
                        this.nameResto = res.resto.name
                        localStorage.setItem('resto', JSON.stringify(res.resto));
                    } 
                })
            }
        },
        mounted() {
            this.chkToken()
            const user = JSON.parse(localStorage.getItem('user'));
            this.user = user

            const resto = JSON.parse(localStorage.getItem('resto'));
            this.resto = resto

            this.getSucursales()
        }
    }
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-md-3">
                 <b-card 
                    header-text-variant="white"
                    header-tag="header"
                    header-class="resto-nuevos-pedidos"
                    body-class="body-card-welly1"
                    >
                    <div class="card-welly">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-sm-12 col-md-12">
                                        <img v-if="resto.images[0] != undefined" crossorigin="anonymous" :src="`${apiCoreHtml}/api/file/${resto.images[0].idFile}?token=${user.token}`" class="image-product" width="60%"/>
                                        <!--<img src="@/assets/images/profile.svg" class="image-product" width="50%"/>-->
                                        <br/><br/>
                                        
                                        <h1>{{resto.name}}</h1> 
                                        <br/>
                                    </div>
                                    <div class="col-sm-12 col-md-12">
                                        <hr/>
                                    </div>

                                    <div class="col-sm-12 col-md-12">
                                        <br/>
                                        <b>Dirección:</b> {{resto.address}}
                                        <br/><br/>
                                        <b>Descripción:</b> {{resto.description}}
                                        <br/><br/>

                                        <b>Método de pago:</b>
                                        <br/>
                                        <div class="payment">
                                            <br/>
                                            <b-form class="form-check form-switch form-switch-lg" @click="changeEfective(!resto.paymentWithEfective)">
                                                Efectivo
                                                <input
                                                class="form-check-input"
                                                id="input-1"
                                                type="checkbox"
                                                
                                                v-model="resto.paymentWithEfective" :name="efective"
                                                />
                                            </b-form> 
                                            <b-form class="form-check form-switch form-switch-lg" @click="changeCard(!resto.paymentWithCard)">
                                                Tarjeta
                                                <input
                                                class="form-check-input"
                                                id="input-1"
                                                type="checkbox"
                                                
                                                v-model="resto.paymentWithCard" :name="card"
                                                />
                                            </b-form> 
                                            <br/>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>  
                 </b-card>
            </div>
            <!--
            <div class="col-md-3">
                 <b-card 
                    header-text-variant="white"
                    header-tag="header"
                    header-class="resto-nuevos-pedidos"
                    body-class="body-card-welly1"
                    >
                    <div class="card-welly">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">

                                    <div class=" col-sm-12 col-md-12" style="margin: 10px 0 10px 0;">
                                        Nombre y Apellido <br/>
                                        <b-form-input v-model="name" type="text" placeholder="Ingrese nombre"></b-form-input>
                                        <br/>

                                        Email <br/>
                                        <b-form-input v-model="email" type="text" placeholder="Ingrese email"></b-form-input>
                                        <br/>

                                        Teléfono <br/>
                                        <b-form-input v-model="phone" type="number" placeholder="Ingrese precio"></b-form-input>
                                        <br/>

                                        Contraseña <br/>
                                        <b-form-input v-model="pass" type="password" placeholder="Ingrese contraseña"></b-form-input>
                                        <br/><br/>

                                        <div class="row">
                                            <div class="col-sm-6 col-md-6 text-center1">
                                                <b-button type="submit" variant="outline-secondary" v-on:click="edit()" style="width:100%;">
                                                    Editar datos
                                                </b-button>
                                            </div>

                                            <div class="col-sm-6 col-md-6 text-center1">
                                                <b-button type="submit" variant="success" v-on:click="save()" style="width:100%; position:relative; left: -10px;">
                                                    Guardar datos
                                                </b-button>
                                            </div>
                                        </div>

                                        <br/><br/><br/>
                                        <br/><br/><br/>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  
                 </b-card>
            </div>
            -->
            <div class="col-md-9">
                 <b-card 
                    header-text-variant="white"
                    header-tag="header"
                    header-class="resto-nuevos-pedidos"
                    body-class="body-card-welly1"
                    >
                    <div class="card-welly">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">

                                    <div v-if="sucursales == null" class="col-sm-12 col-md-12 center" style="margin: 10px 0 10px 0;" >

                                        <br/><br/><br/>
                                        <br/><br/><br/>
                                        
                                        <img src="@/assets/images/ups.png" class="image-product" style="width:20%;"/>
                                        <br/><br/>

                                        <div v-if="!resto.isSucursal">
                                            <span style="font-size: 1.2em;">Ups! aún no tienes sucursales creadas</span><br/>
                                            Para ver las sucursales aquí, completa el formulario<br/>
                                        </div>

                                        <div v-if="resto.isSucursal">
                                            <span style="font-size: 1.2em;">Actualmente no tienes privilegios para modificar los datos del resto</span><br/>
                                            Contacta al administrador<br/>
                                        </div>

                                        <br/><br/>

                                    </div>

                                    <div v-if="sucursales != null" class="col-sm-12 col-md-12 center" style="margin: 10px 0 10px 0;">
                                        <div class="table-responsive">
                                            <table class="table mb-0">
                                                <thead class="table-head">
                                                    <tr>
                                                        <th style="width:5%;">No.</th>
                                                        <th style="width:25%;">Nombre</th>
                                                        <th style="width:30%;">Dirección</th>
                                                        <th style="width:15%;">Estado</th>
                                                    </tr>
                                                </thead>
                                                <tbody class="table-body">
                                                    <tr v-for="(sucursal,index) in sucursales" :key="index">
                                                        <th>{{index + 1}}</th>
                                                        <th>
                                                            <b>{{sucursal.aliasSucursal}}</b>
                                                            <br/>
                                                            {{sucursal.name}}
                                                        </th>
                                                        <th>
                                                            {{sucursal.address}}
                                                            <br/>
                                                            <span style="font-size:0.7em;">{{sucursal.lat}}, {{sucursal.lng}}</span>
                                                        </th>
                                                        <th>{{sucursal.validateWelly ? 'AUTORIZADO' : 'EN VERIFICACIÓN'}}</th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="col-sm-12 col-md-12 right" v-if="!resto.isSucursal">
                                        <b-button type="submit" variant="success" href="/welly/newsucursal">
                                            Crear Sucursal
                                        </b-button>
                                    </div>

                                    <br/><br/>
                                
                                </div>
                            </div>
                        </div>
                    </div>
                 </b-card>
            </div>
        </div>
        
        <br/><br/><br/>

    </Layout>
</template>

<style scoped>

</style>